import React from 'react';
import {
  CContainer,
  CRow,
  CCol,
  CCard,
  CCardBody,
  CCardHeader,
  CBreadcrumb,
  CBreadcrumbItem,
} from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import ShipmentInputs from '../../components/ShipmentStatusInputs/ShipmentStatusInputs';
import { connect } from 'react-redux';
import { useTranslation } from '../../hooks/useTranslation';
import {
  createShipmentStatusRequestAction,
} from '../../store/shipmentStatus/shipmentStatusActions';

const CreateShipmentStatus = ({ createShipmentStatusRequest, 
  isLoading, createShipmentStatusData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleShipmentSubmit = (shipmentStatusData) => {
    createShipmentStatusRequest({
      data: shipmentStatusData,
      navigate: navigate,
    });
  };

  const handleBackToShipments = () => {
    navigate('/shipment-status');
  };

  return (
    <div>
      <CContainer>
        <CBreadcrumb className="mb-4">
          <CBreadcrumbItem
            href="#/shipment-status"
            onClick={(e) => {
              e.preventDefault();
              handleBackToShipments();
            }}
          >
            {t('Shipment Status')}
          </CBreadcrumbItem>
          <CBreadcrumbItem active>{t('createShipmentStatus')}</CBreadcrumbItem>
        </CBreadcrumb>

        <CRow>
          <CCol xs={12}>
            <CCard>
              <CCardHeader>
                <h4 className="mb-0">{t('createShipmentStatus')}</h4>
              </CCardHeader>
              <CCardBody>
                <ShipmentInputs
                  onSubmit={handleShipmentSubmit}
                  onCancel={handleBackToShipments}
                  isLoading={isLoading}
                  submitResponse={createShipmentStatusData}
                />
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer?.isLoading || false,
  createShipmentStatusData: state.shipmentStatusReducer?.createShipmentStatusData || null,
});

const mapDispatchToProps = (dispatch) => ({
  createShipmentStatusRequest: (payload) => dispatch(createShipmentStatusRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateShipmentStatus);
